export default "__VITE_ASSET__CppnL_z0__"